'use client';

import React, { useState } from 'react';
import { X } from 'lucide-react';

type ChipState = {
  requested: boolean;
  approved: boolean;
  replenishment: boolean;
};

export default function ReplenishmentActions() {
  const [freshChips, setFreshChips] = useState<ChipState>({
    requested: false,
    approved: false,
    replenishment: false,
  });
  const [partialChips, setPartialChips] = useState<ChipState>({
    requested: false,
    approved: false,
    replenishment: false,
  });

  const toggleChip = (type: 'fresh' | 'partial', chip: keyof ChipState) => {
    if (type === 'fresh') {
      setFreshChips((prev) => ({ ...prev, [chip]: !prev[chip] }));
    } else {
      setPartialChips((prev) => ({ ...prev, [chip]: !prev[chip] }));
    }
  };

  const chipKeys: (keyof ChipState)[] = ['requested', 'approved', 'replenishment'];

  return (
    <div className="flex flex-col sm:flex-row gap-3">
      {/* Fresh Replenishment */}
      <div className="flex flex-col gap-1.5 flex-1">
        <button className="gradient-fresh text-white text-sm font-600 px-5 py-2.5 rounded-lg btn-scale hover:opacity-90 transition-opacity">
          Fresh Replenishment
        </button>
        <div className="flex gap-1.5 flex-wrap">
          {chipKeys.map((chip) => (
            <button
              key={`fresh-chip-${chip}`}
              onClick={() => toggleChip('fresh', chip)}
              className={`flex items-center gap-1 text-[11px] font-500 px-2.5 py-1 rounded-full border transition-all btn-scale capitalize ${freshChips[chip] ? 'chip-active' : 'chip-inactive'}`}
            >
              {chip}
              <X size={10} />
            </button>
          ))}
        </div>
      </div>

      {/* Partial Replenishment */}
      <div className="flex flex-col gap-1.5 flex-1">
        <button className="gradient-partial text-white text-sm font-600 px-5 py-2.5 rounded-lg btn-scale hover:opacity-90 transition-opacity">
          Partial Replenishment
        </button>
        <div className="flex gap-1.5 flex-wrap">
          {chipKeys.map((chip) => (
            <button
              key={`partial-chip-${chip}`}
              onClick={() => toggleChip('partial', chip)}
              className={`flex items-center gap-1 text-[11px] font-500 px-2.5 py-1 rounded-full border transition-all btn-scale capitalize ${partialChips[chip] ? 'chip-active' : 'chip-inactive'}`}
            >
              {chip}
              <X size={10} />
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}